import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PremiumPartnerPage from '../pages/PartnerPages/PremiumPartnerPage2';
import partnerConfig from '../config/partners/azamara_cruises2';

const partnerId = window.gon.partner_id || '';

const PartnerPage = () => (
  <Router>
    <Switch>
      <Route
        exact path={`/${partnerConfig.path}`}
        render={(props) => (
          <PremiumPartnerPage
            {...props}
            partnerId={partnerId}
            partnerConfig={partnerConfig}
          />
        )}
      />
    </Switch>
  </Router>
);

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<PartnerPage />, document.body.appendChild(document.createElement('div')))
});
